/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { mj } from './page-mj.js';

import { htmlspecialchars, x_split } from './util.js';

import { MCUnknown } from './media.unknown.js';

import { disableMediaViewBGCtrlsToolbar, setupMediaViewBGCtrlsToolbar } from './media-view-bg-ctrls-toolbar.js';
import { ToolbarSetupUtil } from './media-view-toolbar-util.js';

export let MCContainer = function() {

	var media_class = 6;


	function createPreview_Container( dtinfo, target, xopts, toolbarSetupUtil ) {

		var md_trg = $(target),
			media_id = dtinfo.media_id,
			meta = dtinfo.meta,
			mc = meta[-1] ? meta[-1][0] : media_class,
			vq = !dtinfo.is_latest_version ? '&v='+encodeURIComponent(dtinfo.version) : '';

		var md_preview_filename = null;

		function resize_handler(e,w,h) {
			var md_view_w = Math.max(10,w-10);
			var md_view_h = Math.max(10,h-10);
			var iw = Math.min(md_view_w,240), ih = Math.min(md_view_h,240);

			let preview_html = '';
			if( md_preview_filename !== null ) {
				const path_arr = x_split(md_preview_filename,'/');
				const path_str = path_arr.map( (pc) => encodeURIComponent(pc) ).join('/');

				var iframe_src = mj.fixAssetURL(mj.webroot+'media/file/container/id/'+media_id+'/path/'+path_str);
				preview_html = '<iframe src="'+htmlspecialchars(iframe_src,true,true)+'"'
									+' marginheight="0" marginwidth="0" frameborder="0" width="100%" height="100%"'
									+' allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"'
									+' sandbox="allow-scripts allow-downloads allow-same-origin"'
									+' />';
			}
			md_trg.children('.md-empty-canvas')
				.css( {
					background:	'transparent url(' + mj.fixAssetURL(mj.webroot+'media/file/thumb/id/'+media_id+'_'+mc+'_'+iw+'_'+ih+'.png?m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq) + ') center center no-repeat',
					width: md_view_w+'px',
					height: md_view_h+'px',
				} )
				.html(preview_html);
				// .children('iframe')
				// .one('load.MCContainer',function() {
				// 	const iframe_elem = $('iframe',md_trg)[0];
				// 	var viewer_window = iframe_elem.contentWindow;
				// 	var vdoc = viewer_window.document;

				// 	const vbody = vdoc.querySelector('body');
				// 	const elem = vbody.firstElementChild ?? vbody;

				// 	const vbodyBCR = elem.getBoundingClientRect();

				// 	// TODO: ..
				// 	// iframe_elem.width = vbodyBCR.width;
				// 	// iframe_elem.height = vbodyBCR.height;

				// 	// console.log({vbodyBCR});
				// } );
		}


		md_trg
			.off('.MCContainer')
			.html('<div class="md-empty-canvas"></div>')
			.on('mjsclose.MCContainer', function(e) {
				md_trg.off('.MCContainer');
			})
			.on('mjsresize.MCContainer',resize_handler)
			.on('mjscontainerfilepreviewsetup.MCContainer', function( e, filename ) {
				// console.log({w:'mjscontainerfilepreviewsetup',filename});
				md_preview_filename = filename;
				resize_handler(null,md_trg.width(),md_trg.height());
			} );


		resize_handler(null,md_trg.width(),md_trg.height());
	}


	return Object.assign( {}, MCUnknown, {

		init: function() {
		},

		// createThumbnail: function( media_id, meta, target, iw, ih, version, on_load_cb ) {
		// },

		createPreview: function( dtinfo, target, xopts ) {
			const md_trg = $(target);
			disableMediaViewBGCtrlsToolbar( md_trg );

			const has_custom_preview = dtinfo.meta[10] && dtinfo.meta[10][0] > 0;
			if( has_custom_preview ) {
				return MCUnknown.createPreview(dtinfo,target,xopts);
			}
			// const src_format = meta[-2]&&meta[-2][0] ? meta[-2][0] : 'application/octet-stream';
			let toolbarSetupUtil = new ToolbarSetupUtil();
			setupMediaViewBGCtrlsToolbar( md_trg, xopts, (toolbar) => toolbarSetupUtil.onToolbarSetup(toolbar) );
			return createPreview_Container(dtinfo,md_trg[0],xopts,toolbarSetupUtil);
		},
	} );
}(); // namespace MCContainer
